const PREVIEW_URL = process.env.PREVIEW_URL;
if (!PREVIEW_URL) {
  throw new Error('PREVIEW_URL is not set');
}
if (PREVIEW_URL.endsWith('/')) {
  throw new Error('PREVIEW_URL must not end with a slash');
}

export const previewPathToUrl = (libraryId: string, mediaId: string, filePath: string) => {
  return `${PREVIEW_URL}/${libraryId}/${mediaId}${filePath}`;
};

/**
 * The HLS manifest's path on the preview host, as a `previewPathToUrl` file path.
 * Lives here because the layout is the preview host's, not any one player's.
 */
export const HLS_PLAYLIST_PATH = '/media/preview/hls/playlist.m3u8';
